export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'long', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Влизане",
    "login.form.hint.user": "Потребителско име",
    "login.form.hint.password": "Парола",
    "login.form.checkbox.remember-me": "Запомни ме",
    "login.form.button.sign-in": "Влизане",
    "login.form.message.invalid-user-credentials": "Потребителското име или паролата е неправилна",
    "login.form.message.account-temporarily-locked": "Акаунтът ви е временно заключен, върнете се след 5 минути",
    "login.form.message.user-required": "Въведете потребителско име",
    "login.form.message.password-required": "Въведете парола",
    "login.form.button.forgot-password": "Забравена парола?",
    "error.mfa-required.title": "Настройване на двуфакторното удостоверяване (2FA)",
    "error.mfa-required.message1": "Двуфакторното удостоверяване (2FA) е необходимо за защита на акаунта Ви.",
    "error.mfa-required.message2": "Ще бъдете пренасочени към настройките на акаунта си в Online Dashboard. Активирайте 2FA, следвайте инструкциите за настройка и след това се върнете тук.",
    "error.mfa-required.learnMore": "Научете повече за двуфакторното удостоверяване (2FA)",
    "error.mfa-required.continue": "Продължаване",
    "error.root-admin-login.title": "Грешка 403 – забранено",
    "error.root-admin-login.message": "Влезли сте като администратор с роля само за четене. За да осъществите достъп до конзолата Web Recovery, влезте като потребител наемател от тип „клиент“ или администратор",
    "error.server-busy.message": "Сървърът е зает, опитайте отново по-късно.",
    "error.network-connection.title": "Грешка в мрежовата връзка",
    "error.network-connection.message": "Проверете интернет връзката си и опитайте отново.",
    "error.internal-server-error.title": "Вътрешна грешка в сървъра",
    "error.internal-server-error.message": "За да поправите грешката, се свържете с отдела за поддръжка с подробни данни за нея:",
    "error.internal-server-error.copy.button": "Копиране"
};
